import { Action, createReducer, on } from '@ngrx/store';
import { initialResidentsState, ResidentsState } from './residents.state';
import { approvalsLoaded } from './residents.actions';

export function residentsReducer(state: ResidentsState | undefined, action: Action) {
  return createReducer(
    initialResidentsState,
    // on(residentsLoaded, (currentState: ResidentsState, { residents }) => ({...currentState, residents: residents})),
    on(approvalsLoaded, (currentState: ResidentsState, { approvals }) => ({...currentState, approvals: approvals}))
  )(state, action);
}
